module.exports = __webpack_public_path__ + "img/RAY_WELD.5427d555.jpg";